(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-menue"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', e => {
    const alle = [...document.querySelectorAll('[data-mm-knopf]')];
    if (!alle.length) return;
    const knopf = e.target.closest('[data-mm-knopf]');
    if (!knopf) { if (!e.target.closest('[data-mm-panel]')) zu(alle); return; }
    const offen = knopf.getAttribute('aria-expanded') === 'true';
    zu(alle);
    if (!offen) auf(knopf);
  });
  // ---- Schublade auf dem Telefon ----------------------------------------
  document.addEventListener('click', e => {
    const sek = document.querySelector('.mm-sektion');
    if (!sek) return;
    if (e.target.closest('[data-mm-burger]')) { auf_schublade(sek, true); return; }
    if (e.target.closest('[data-mm-zu]')) { auf_schublade(sek, false); return; }
    // Ein Klick auf einen Link schliesst die Schublade — sonst bleibt sie
    // offen ueber der Seite stehen, zu der man gerade wollte.
    if (e.target.closest('.mm__nav a')) auf_schublade(sek, false);
  });
  function auf_schublade(sek, offen) {
    sek.toggleAttribute('data-offen', offen);
    const b = sek.querySelector('[data-mm-burger]');
    if (b) b.setAttribute('aria-expanded', offen ? 'true' : 'false');
    // Seite dahinter feststellen, sonst scrollt sie unter der Schublade weg.
    document.documentElement.style.overflow = offen ? 'hidden' : '';
    if (offen) sek.querySelector('[data-mm-zu]')?.focus();
    else b?.focus();
  }

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const sek = document.querySelector('.mm-sektion[data-offen]');
    if (sek) { auf_schublade(sek, false); return; }
    const alle = [...document.querySelectorAll('[data-mm-knopf]')];
    const war = alle.find(k => k.getAttribute('aria-expanded') === 'true');
    zu(alle);
    if (war) war.focus();     // Fokus zurueck, sonst landet er im Nichts
  });
  function auf(k) {
    k.setAttribute('aria-expanded', 'true');
    const p = document.getElementById(k.getAttribute('aria-controls'));
    if (!p) return;
    p.removeAttribute('hidden');
    // Ein Bild warten, sonst springt der Uebergang ueber den Anfangswert.
    requestAnimationFrame(() => requestAnimationFrame(() => p.classList.add('mm__panel--auf')));
  }
  function zu(alle) {
    alle.forEach(k => {
      const war = k.getAttribute('aria-expanded') === 'true';
      k.setAttribute('aria-expanded', 'false');
      const p = document.getElementById(k.getAttribute('aria-controls'));
      if (!p) return;
      p.classList.remove('mm__panel--auf');
      if (!war) { p.setAttribute('hidden', ''); return; }
      // Nach dem Uebergang verstecken — sonst bleibt es fuer Tastatur und
      // Screenreader erreichbar, obwohl es unsichtbar ist.
      setTimeout(() => { if (!p.classList.contains('mm__panel--auf')) p.setAttribute('hidden', ''); }, 220);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
